/**
 * A review's `patientId` is stored two ways: some documents hold the patient
 * object, others hold the national ID string. The supervisor screens all read
 * `review.patientId?.nationalId`, so for the string form they resolved to
 * undefined and the "View Full Patient Info" button was hidden entirely -
 * leaving faculty no way to open the record.
 *
 * Both shapes resolve through here.
 */

/** The national ID for a review, or null when the reference carries none. */
export const patientNationalId = (patientRef) => {
  if (!patientRef) return null;
  if (typeof patientRef === 'string') return patientRef.trim() || null;
  if (typeof patientRef === 'object') {
    return patientRef.nationalId || patientRef.id || null;
  }
  return null;
};

/** A display name for a review's patient, falling back to the ID. */
export const patientDisplayName = (patientRef, fallback = 'Unnamed patient') => {
  if (!patientRef) return fallback;
  if (typeof patientRef === 'object') {
    return patientRef.fullName || patientRef.name || patientRef.nationalId || fallback;
  }
  if (typeof patientRef === 'string') return patientRef.trim() || fallback;
  return fallback;
};

export default patientNationalId;
